<script lang="ts" setup>
const { siteName } = useSite()

useHead({
  titleTemplate: (titleChunk) => {
    return titleChunk ? `${titleChunk} | ${siteName.value}` : siteName.value
  },
})
</script>

<template>
  <NuxtPage />

  <ConfirmDialog />
  <DynamicDialog />
  <Toast />
</template>
